import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

export default StyledLink;
